/// <reference path="../../types.d.ts" />

import { LOAD_STATES } from '../../reducers/common';
import { DEFAULT_HEALTH_SYSTEM } from './health-systems';
import { DEFAULT_SERVICE_LINE } from './service-lines';
import { DEFAULT_PRESET_ID, presetToRange } from './date-presets';

export const automationDashboard: CMx.AutomationDashboardState = {
  filters: {
    health_system_code: DEFAULT_HEALTH_SYSTEM,
    service_line: DEFAULT_SERVICE_LINE,
    tenant_code: ''
  },
  dateRangePresetId: DEFAULT_PRESET_ID,
  dateRange: presetToRange(DEFAULT_PRESET_ID),
  loadState: LOAD_STATES.initial,
  data: null,
  error: null,
  filterOptions: null,
  freshness: null
};
